/**
 * Apollo Client's developer-only console messages (DHT-5552). Apollo logs them
 * through `invariant.error` as a `go.apollo.dev/c/err#{...}` URL whose payload
 * can serialise cache records, appointment and medical-record notes included.
 * Production builds made after DHT-5552 compile them out; this catches the
 * ones still sent by browser tabs running a bundle built before it.
 *
 * Kept apart from `isThirdPartyError`: these come from our own bundle, not from
 * code we do not ship.
 */

const APOLLO_DEV_ERROR = "go.apollo.dev/c/err";

/**
 * True when an error event carries an Apollo developer message and should be
 * dropped. Never throws: anything it cannot read is kept, because losing a
 * real error is worse than keeping noise, and a throw inside `beforeSend`
 * would break every event.
 */
export const isApolloDevError = (event: unknown): boolean => {
  try {
    const message = (event as { error?: { message?: unknown } })?.error
      ?.message;
    return typeof message === "string" && message.includes(APOLLO_DEV_ERROR);
  } catch {
    return false;
  }
};
